import { useQuery } from '@apollo/react-hooks';
import React from 'react';
import { LIST_PRODUCT_OPTIONS } from '../graphql';

const useListProductOption = ({
  type,
  fromProducts,
  toProducts
}, options) => {
  const list = useQuery(LIST_PRODUCT_OPTIONS, {
    variables: {
      type,
      from_product: fromProducts === null || fromProducts === void 0 ? void 0 : fromProducts.join(','),
      to_product: toProducts === null || toProducts === void 0 ? void 0 : toProducts.join(',')
    },
    skip: fromProducts.length === 0,
    ...options
  });
  const productOptions = React.useMemo(() => {
    if (!list.data) {
      return [];
    }

    return list.data.productOptions;
  }, [list.data]);
  return [productOptions, list];
};

export default useListProductOption;